import React from 'react';
import moment from 'moment';
import Avatar from 'react-avatar';
import { UserMessage } from './UserMessage';
export var UserMessageGroup = function UserMessageGroup(_ref) {
  var discussion = _ref.discussion,
      messages = _ref.messages,
      profile = _ref.profile,
      actions = _ref.actions;
  return /*#__PURE__*/React.createElement("div", {
    className: "messages__grouping ".concat(messages.first().createdBy.username === profile.username ? 'is-mine' : 'is-other')
  }, messages.first().createdBy.username !== profile.username && /*#__PURE__*/React.createElement(Avatar, {
    size: 36,
    email: messages.first().createdBy.email,
    name: messages.first().createdBy.displayName,
    round: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "message-list"
  }, messages.map(function (message) {
    return /*#__PURE__*/React.createElement(UserMessage, {
      key: message.id,
      discussion: discussion,
      message: message,
      actions: actions,
      profile: profile
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: "meta"
  }, /*#__PURE__*/React.createElement("span", {
    className: "author"
  }, messages.last().createdBy.username === profile.username ? 'You' : messages.last().createdBy.displayName), /*#__PURE__*/React.createElement("span", {
    className: "timestamp"
  }, moment(messages.last().createdAt).format('h:mma')))));
};